<template>
  <div class="upload-strip-image">
    <div style="text-align: center" v-if="error">
      <h3>🚨</h3>
      <p>
        {{error}} <br>
        <a @click="reset">Retry</a>
      </p>
    </div>
    <div v-else>
      <file-select
        :label="label"
        :progress="progress"
        @select="upload"
      />
    </div>
  </div>
</template>

<script>
import { CLOUD_NAME, COMIC_PRESET } from '@/utilities/cloudinaryKeys';
import cloudinaryUpload from '@/utilities/cloudinaryUpload';
import FileSelect from '@/components/FileSelect.vue';

export default {
  name: 'UploadStripImage',
  props: {
    label: String,
  },
  components: {
    FileSelect,
  },
  data() {
    return {
      progress: 0,
      error: null,
    };
  },
  methods: {
    upload(file) {
      const vm = this;
      vm.progress = 1;
      cloudinaryUpload({
        cloudName: CLOUD_NAME,
        preset: COMIC_PRESET,
        file,
        onProgress({ progress }) {
          vm.progress = progress;
        },
      }).then((response) => {
        const transformations = response.eager.map(upload => upload.secure_url);
        this.$emit('complete', {
          file,
          images: {
            urlThumb: transformations[0],
            url: transformations[1],
            urlMobile: transformations[2],
          },
        });
      }).catch((e) => {
        vm.error = e && e.message;
      });
    },
    reset() {
      this.progress = 0;
      this.error = null;
    },
  },
};
</script>
